import React from "react";
import { Link } from "react-router-dom";
import WebLayout from "../components/WebLayout";
import Seo from "../components/Seo";
import { MapPin, ArrowRight } from "lucide-react";

export default function NotFound() {
  return (
    <WebLayout>
      <Seo title="Page Not Found" description="The page you were looking for could not be found." path="/404" noindex />
      <section className="max-w-2xl mx-auto px-6 py-24 text-center">
        <div className="inline-flex items-center gap-2 text-[#FFC107]"><MapPin size={16} /> <span className="sb-eyebrow" style={{ color: "#FFC107" }}>404</span></div>
        <h1 className="sb-headline mt-4 text-[48px] md:text-[64px]">SPOT NOT <span className="text-[#FFC107]">FOUND.</span></h1>
        <p className="mt-5 text-[#A1A1AA]">The page you were looking for doesn't exist or has moved. Head back to base or explore what SpotBounty is building.</p>
        <div className="mt-8 flex items-center justify-center gap-3 flex-wrap">
          <Link to="/" data-testid="404-home" className="sb-btn-primary text-[12px]" style={{ padding: "12px 20px" }}>
            Back to Home <ArrowRight size={14} />
          </Link>
          <Link to="/faq" data-testid="404-faq" className="sb-btn-secondary text-[12px]" style={{ padding: "12px 20px" }}>
            FAQ
          </Link>
        </div>
      </section>
    </WebLayout>
  );
}
